module.exports = __webpack_public_path__ + "2c535af7bca91473b46427852fc1f3e5.svg";